import { toast } from "react-toastify";
import { getClientSeriesRateFromDb, getRateFromDbForLogistic, getRateMasterNewFromDb } from "./CommonService";

export function getRateFormateViaClientCode(clientList,client){
    const clientBean = clientList.find(
        cl=>cl.client_code===client
    );
    return clientBean.rate_format?clientBean.rate_format:"";
}

// export function getServiceGroupCode(serviceList,serviceCode){
//     const service = serviceList.find(
//         serv=>serv.service_code===serviceCode
//     )

//     return service.service_group_code? service.service_group_code:serviceCode;
// }

export function getRateTypeViaClientCode(clientList,client){
    const clientBean = clientList.find(
        cl=>cl.client_code===client
    )
    return clientBean.rate_type;
}

export function getZoneViaCityCode(masterData,cityCode){
    const areaList = masterData.LIST_PINCODE;
    const areaBean = areaList.find(
        area=>area.city_code===cityCode
    )
    // console.log("areaBean ",areaBean);
    return areaBean.zon_code;
}

export function checkZoneType(loadRateForAutoCalculationList,client,network,service,city,setZONECODE_MAPPED_WITHCITY){
    let zoneType = '';
    // console.log("response 2",loadRateForAutoCalculationList)
    for(let i of loadRateForAutoCalculationList){
        if(i.client_code===client && i.network_code === network && i.service_code === service){
            // console.log(i,"bean i");
            if(i.zone_code===city){
                zoneType = i.zone_type;
                // console.log("bean i ",i);
                break;
            }
            else if(setZONECODE_MAPPED_WITHCITY===i.zone_code){
                zoneType= i.zone_type;
                // console.log("bean i ",i);
                break;
            }
        }
    }
    return zoneType;
}

export function getServiceGroupCode(masterData,service){
    const serviceList = masterData.LIST_SERVICE;
    for(let i of serviceList){
        if(service===i.ser_code){
            service = i.group_code;
            break;
        }
    }
    return service;
}

export async function calculateFriegthAmount(masterData,client, network, service, cityCode, billingWt,packet, rateType){

    let B_nearest = 0, E_nearest = 0, K_nearest = 0, E_addLimt = 0, B_zoneAmount = 0, E_zoneAmount = 0,
            K_zoneAmount = 0, total = 0;
    let B_rateType = "", E_rateType = "", K_rateType = "", zoneType = null, zone_code = null;
    let B_slno = 0, E_slno = 0, K_slno = 0;

    let isKgAvailable = false, isAddAvailable = true;

    let setORIGINAL_ZONECODE;
    let setZONECODE_MAPPED_WITHCITY;
    let setWEIGHT_TYPE;
    let setWEIGHT_SLAB;
    const zoneCode = getZoneViaCityCode(masterData,cityCode);
    setORIGINAL_ZONECODE = zoneCode;
    setZONECODE_MAPPED_WITHCITY = zoneCode;
    masterData.setZONECODE_MAPPED_WITHCITY(zoneCode);
    masterData.setORIGINAL_ZONECODE(zoneCode);
    const response =await getRateMasterNewFromDb(client);
    masterData.setList_loadRateForAutoCalculation(response);
    zoneType = checkZoneType(response,client,network,service,cityCode,setZONECODE_MAPPED_WITHCITY);
    if (zoneType === "S") {
        zone_code = cityCode;
    } else {
        zone_code = setZONECODE_MAPPED_WITHCITY;
    }
    // console.log(zoneType+" zonetype");
    // console.log(zone_code+" zone Code");
    // console.log(setZONECODE_MAPPED_WITHCITY,"setZONECODE_MAPPED_WITHCITY")
    // console.log(setORIGINAL_ZONECODE,"setORIGINAL_ZONECODE")

     for (let imBean of response) {

        if ((client===imBean.client_code) && (network===imBean.network_code) && (service===imBean.service_code) && (imBean.rate_type.toUpperCase()==="E") && (zoneType===imBean.zone_type) && (zone_code===imBean.zone_code)) {

            if (imBean.add_limit >= billingWt) {
                isKgAvailable = false;
                break;
            } else {
                isKgAvailable = true;
                break;
            }
        } else if ((client===imBean.client_code) && (network===imBean.network_code) && (service===imBean.service_code) && (imBean.rate_type.toUpperCase()==="K") && (zoneType===imBean.zone_type) && (zone_code===imBean.zone_code)) {

            if (true) {
                isKgAvailable = true;
                break;
            }
        }

    }


    if (isKgAvailable) {

        for (let imBean of response) {
            if ((client===imBean.client_code) && (network===imBean.network_code) && (service===imBean.service_code) && (imBean.rate_type.toUpperCase()==="K") && (zoneType===imBean.zone_type) && (zone_code===imBean.zone_code)) {
                if (imBean.slab >= billingWt) {

                    K_nearest = imBean.slab;

                    K_zoneAmount = imBean.rate;

                    K_slno = imBean.sno;
                    K_rateType = imBean.rate_type;
                    setWEIGHT_TYPE = "K";
                    setWEIGHT_SLAB = imBean.slab;
                    masterData.setWEIGHT_TYPE("K");
                    masterData.setWEIGHT_SLAB(imBean.slab);
                    isKgAvailable = true;
                    break;
                } else {
                    K_nearest = imBean.slab;
                    K_zoneAmount = imBean.rate;
                    K_slno = imBean.sno;
                    K_rateType = imBean.rate_type;
                    setWEIGHT_TYPE = "K";
                    setWEIGHT_SLAB = imBean.slab;
                    masterData.setWEIGHT_TYPE("K");
                    masterData.setWEIGHT_SLAB(imBean.slab);
                    isKgAvailable = true;
                }
            }
        }
    }

    if (isKgAvailable===false) {
        for (let imBean of response) {
            if ((client===imBean.client_code) && (network===imBean.network_code) && (service===imBean.service_code) && (imBean.rate_type.toUpperCase()==="B") && (zoneType===imBean.zone_type) && (zone_code===imBean.zone_code)) {
        
                B_zoneAmount = imBean.rate;

                setWEIGHT_TYPE = "B";
                setWEIGHT_SLAB = imBean.slab;
                masterData.setWEIGHT_TYPE("B");
                masterData.setWEIGHT_SLAB(imBean.slab);
                B_slno = imBean.sno;
                B_rateType = imBean.rate_type;
                B_nearest = imBean.slab;

                if (B_nearest >= billingWt) {
                    isAddAvailable = false;
                    break;
                }
            }
        }
        if (isAddAvailable == true) {
            for (let imBean of response) {
                if ((client===imBean.client_code) && (network===imBean.network_code) && (service===imBean.service_code) && (imBean.rate_type.toUpperCase()==="E") && (zoneType===imBean.zone_type) && (zone_code===imBean.zone_code)) {
        
                    E_zoneAmount = imBean.rate;

                    setWEIGHT_TYPE = "E";
                    setWEIGHT_SLAB = imBean.add_limit;
                    masterData.setWEIGHT_TYPE("E");
                    masterData.setWEIGHT_SLAB(imBean.add_limit);
                    E_addLimt = imBean.add_limit;
                    E_slno = imBean.sno;
                    E_rateType = imBean.rate_type;
                    E_nearest = imBean.slab;
                    break;
                }
            }
        }
    }

    total = basicRateFormula(B_slno, B_zoneAmount) + addRateFormula(E_slno, E_zoneAmount, B_nearest, E_nearest, billingWt) + kgRateFormula(K_slno, K_zoneAmount, rateType, billingWt, packet);
    console.log("total ==========================", total);
    // return total;
    return {
        freigthtotal:total,
        originZoneCode:setORIGINAL_ZONECODE,
        zoneCodeMappedWithCity:setZONECODE_MAPPED_WITHCITY,
        weigthType: setWEIGHT_TYPE,
        weigthSlab: setWEIGHT_SLAB
    };
}

export async function calculateFriegthAmountForLogistic(masterData,client,network,service,originCity,destCity,billingWt,packet,rateType){

    let setORIGINAL_ZONECODE;
    let setZONECODE_MAPPED_WITHCITY;
    let setWEIGHT_TYPE;
    let setWEIGHT_SLAB;

    let originZone = "", destinationZone = "";
    let originFound = false, destinationFound = false;
    for(let i of masterData.LIST_PINCODE){
        if(originCity===i.city_code){
            originZone = i.zon_code_kg;
            originFound = true;
        }

        if(destCity === i.city_code){
            setZONECODE_MAPPED_WITHCITY = i.zon_code_kg;
            masterData.setZONECODE_MAPPED_WITHCITY(i.zon_code_kg);
            destinationZone = i.zon_code_kg;
            destinationFound = true;
        }

        if(originFound && destinationFound){
            break;
        }
    }

    if (!destinationFound) {
        return 0;
    }
    if (!originFound) {
        return 0;
    }

    const rateForLogistic = await getRateFromDbForLogistic(client);
    masterData.setList_loadRateForAutoCalculation(rateForLogistic);

    for(let imBean of rateForLogistic){
        if ((client===imBean.client_code) && (network===imBean.network_code)
                    && (service===imBean.service_code) && (originZone===imBean.origin_code)
                    && (destinationZone===imBean.destination_code)) {
            masterData.setWEIGHT_SLAB(0);
            masterData.setWEIGHT_TYPE("");
            const wtLimit = getLogisticWtLimit(masterData,client);
            const total =  logisticRateFormula(imBean.rate,rateType,billingWt,packet,wtLimit);
            return {
                freigthtotal:total,
                originZoneCode:setORIGINAL_ZONECODE,
                zoneCodeMappedWithCity:setZONECODE_MAPPED_WITHCITY,
                weigthType: setWEIGHT_TYPE,
                weigthSlab: setWEIGHT_SLAB
            }
        }
    }
    return 0;
}

export async function friegthAmount(masterData,clientCode,specialEntry,networkCode,serviceCode,billingWt,packet,originCity,cityDestCode){
    const clientList = masterData.LIST_CLIENT;
    let freigthAmt = 0;
    if(specialEntry==='F'){
        const rateFormate = getRateFormateViaClientCode(clientList,clientCode);
        const rateType = getRateTypeViaClientCode(clientList,clientCode);
        console.log(rateFormate+" rate formate");
        if(rateFormate==='B' || rateFormate===''){
            console.log("rateType "+rateType);
            return await calculateFriegthAmount(masterData,clientCode,networkCode,serviceCode,cityDestCode,billingWt,packet,rateType);
        }else if(rateFormate==='K'){
            return await calculateFriegthAmountForLogistic(masterData,clientCode,networkCode,serviceCode,originCity,cityDestCode,billingWt,packet,rateType)
        }
    }
}


// calculation of basic to get total friegth amount
export function basicRateFormula(b_slNo, amount) {
        let basicAmt = 0;
        if (b_slNo != 0) {
            basicAmt = amount;
        }
        return basicAmt;
}

export function addRateFormula(e_slNo, amount, b_nearest, e_nearest, billWt) {
      
  let addAmt = 0;
    if (e_slNo != 0) {
        addAmt = amount * Math.ceil((billWt - b_nearest) / e_nearest);
    }

    return addAmt;
}

export function kgRateFormula(k_slNo, amount, rateType, billWt, pcs) {
    let kgAmt = 0;
    if (k_slNo != 0) {
        if (rateType == null) {
            kgAmt = Math.ceil(billWt) * amount;
        } else if (rateType==="KG") {
            kgAmt = Math.ceil(billWt) * amount;
        } else if (rateType==="PCS") {
            kgAmt = pcs * amount;
        }
    }
    return kgAmt;
}

export function logisticRateFormula(rate,rateType, billWt, pcs, wtLimit) {
    let amt = 0;
    if (rateType == null) {
        amt = Math.ceil(billWt <= wtLimit ? wtLimit : billWt) * rate;
    } else if (rateType==="KG") {
        amt = Math.ceil(billWt <= wtLimit ? wtLimit : billWt) * rate;
    } else if (rateType==="PCS") {
        amt = pcs * rate;
    }
    return amt;
}

export function getLogisticWtLimit (masterData,clientCode) {
    for (let clBean of masterData.LIST_CLIENT) {
        if (clBean.client_code===clientCode) {
            return clBean.logistic_wt_limit;
        }
    }
    return 0;
}

export async function calculateFuelAmt(
  masterData,
  clientCode,
  networkCode,
  serviceGroupCode,
  FreightAmt,
  vasSubTotal,
  insAmount
) {
  let fuelOnVas = 0;
  let fuelrate = 0;
  const hashMap_ClientVas = new Map();
  let flag = true;

  for (let bean of masterData.LIST_CLIENTVAS) {

    if (
      bean.client_code === clientCode &&
      bean.network_code === networkCode &&
      bean.service_group_code === serviceGroupCode
    ) {

      fuelrate = bean.fuel_rate;

      if (bean.fuel_on_insurance === "T" && bean.fuel_on_vas === "T") {
        fuelOnVas = ((FreightAmt + vasSubTotal) * fuelrate) / 100;

      } else if (bean.fuel_on_insurance === "T") {
        fuelOnVas = ((insAmount + FreightAmt) * fuelrate) / 100;

      } else if (bean.fuel_on_vas === "T") {
        vasSubTotal = vasSubTotal - insAmount;
        fuelOnVas = ((vasSubTotal + FreightAmt) * fuelrate) / 100;

      } else {
        fuelOnVas = (FreightAmt * fuelrate) / 100;
      }

      flag = false;
      break;

    } else if (
      bean.client_code === clientCode &&
      bean.network_code === networkCode &&
      bean.service_group_code === "All"
    ) {
      hashMap_ClientVas.set(0, bean);

    } else if (
      bean.client_code === clientCode &&
      bean.network_code === "All" &&
      bean.service_group_code === serviceGroupCode
    ) {
      hashMap_ClientVas.set(1, bean);

    } else if (
      bean.client_code === clientCode &&
      bean.network_code === "All" &&
      bean.service_group_code === "All"
    ) {
      hashMap_ClientVas.set(2, bean);
    }
  }

  if (flag) {

    let bean;

    if (hashMap_ClientVas.has(0)) {
      bean = hashMap_ClientVas.get(0);

    } else if (hashMap_ClientVas.has(1)) {
      bean = hashMap_ClientVas.get(1);

    } else if (hashMap_ClientVas.has(2)) {
      bean = hashMap_ClientVas.get(2);

    } else {
      console.log("Data Not Found in ClientVAS.");
      return 0;
    }

    fuelrate = bean.fuel_rate;

    if (bean.fuel_on_insurance === "T" && bean.fuel_on_vas === "T") {
      fuelOnVas = ((FreightAmt + vasSubTotal) * fuelrate) / 100;

    } else if (bean.fuel_on_insurance === "T") {
      fuelOnVas = ((insAmount + FreightAmt) * fuelrate) / 100;

    } else if (bean.fuel_on_vas === "T") {
      vasSubTotal = vasSubTotal - insAmount;
      fuelOnVas = ((vasSubTotal + FreightAmt) * fuelrate) / 100;

    } else {
      fuelOnVas = (FreightAmt * fuelrate) / 100;
    }
  }

  return {
    fuelAmt:Number(fuelOnVas.toFixed(2)),
    fuelRate:fuelrate
  };
}

export function getClientCommissionDetails(masterData,clientCode, billWt, freightAmt, fuel){
    let calculatedCommissionAmt = 0;
    let COMMISSION_AMOUNT = 0;
    let COMMISSION_ON_FUEL = '';
    let COMMISSION_TYPE = '';
    for (let bean of masterData.LIST_CLIENT) {
        if (clientCode===bean.client_code) {
            COMMISSION_AMOUNT = bean.commission_amount;
            COMMISSION_ON_FUEL = bean.commission_on_fuel;
            COMMISSION_TYPE = bean.commission_type;
            break;
        }
    }

    if (COMMISSION_TYPE != null) {
        if (COMMISSION_TYPE==="P") {
            if (COMMISSION_ON_FUEL==="Y") {
                calculatedCommissionAmt = ((freightAmt + fuel) * COMMISSION_AMOUNT) / 100;
            } else {
                calculatedCommissionAmt = (freightAmt * COMMISSION_AMOUNT) / 100;
            }
        } else if (COMMISSION_TYPE==="K") {
            calculatedCommissionAmt = billWt * COMMISSION_AMOUNT;
        }
    }

    COMMISSION_AMOUNT = 0;
    COMMISSION_ON_FUEL = null;
    COMMISSION_TYPE = null;

    return calculatedCommissionAmt;
}

// export async function calculateClientVasOnNetworkAndService(masterData,client,network,service) {
//     const hashMap = new Map();
//     let docket_client = '';
//     let docket_charge = 0;
//     for(let clVasBean of masterData.LIST_CLIENTVAS){
//         if ((clVasBean.client_code===client) && (clVasBean.network_code===network) && (clVasBean.service_group_code===service)) {
//              if (true) {
//                     if ("S"===clVasBean.docket_chrg_type) {
//                         if(masterData.LIST_CLIENTSERIESATE.isEmplty()){
//                             const response = await getClientSeriesRateFromDb();
//                             masterData.setLIST_CLIENTSERIESATE(response);
//                         }
//                         docket_client = client;
//                         let charPos = CommonMethods.getLastCharacterPosInString(deBean.getAwb_no());
//                         let fromPrefix = deBean.getAwb_no().substring(0, charPos);
//                         docket_charge = LoadClientSeriesDocket.docketCharge(clientCode, fromPrefix);

//                     } else {
//                         docket_charge=clVasBean.docket_amount;
//                     }
//                 } else {
//                     resultBean.setDocket_charge(deBean.getDocket_charge());
//                 }
//         }
//     }
// }

export function getInsuranceType(masterData, client, service, network) {
    let hashmap_clientVas = new Map();
    let insurType = '';

    for (let clientVas of masterData.LIST_CLIENTVAS) {
        if (client === clientVas.client_code) {

            if (clientVas.service_group_code === service && clientVas.network_code === network) {
                return clientVas.insurance_type;
            }

            if (clientVas.service_group_code === service && clientVas.network_code === 'ALL') {
                hashmap_clientVas.set(0, clientVas);
            } 
            else if (clientVas.network_code === network && clientVas.service_group_code === 'ALL') {
                hashmap_clientVas.set(1, clientVas);
            } 
            else if (clientVas.network_code === 'ALL' && clientVas.service_group_code === 'ALL') {
                hashmap_clientVas.set(2, clientVas);
            }
            // console.log("client vas",clientVas)
        }
    }

    let bean = hashmap_clientVas.get(0) || hashmap_clientVas.get(1) || hashmap_clientVas.get(2);
// console.log("client vas",bean)
    return bean ? bean.insurance_type : ''; 
}
